import React from 'react';
import styled from 'styled-components';
import Price from '../../../shared/Price';

const ProductPrice = styled.span`
  display: block;
  color: #666;
  font-size: 14px;
  margin-top: 0;
  font-weight: 400;
  padding-bottom: 8px;
`;

const ProductSubheader = ({ product }) => (
  <ProductPrice>
    <Price product={product} showZeroAsFree />
  </ProductPrice>
);

export default ProductSubheader;
